export const VAT = {
    Yes: true,
    No: false,
};

export const VATs = [
    { Id: VAT.Yes, TextId: 'yes' },
    { Id: VAT.No, TextId: 'no' },
];
